import type { Tone } from '../../ui/StatusBadge';

/**
 * The hue for an outcome the cluster printed.
 *
 * Matched loosely on purpose: the chain's vocabulary is the cluster's, it
 * grows, and a word neither side knows must read as itself rather than as the
 * nearest thing this console recognises. Anything unmatched is neutral —
 * stated, not judged.
 */
export function outcomeTone(outcome: string): Tone {
  const word = outcome.toLowerCase();
  if (word.includes('deny') || word.includes('fail') || word.includes('refus')) return 'deny';
  if (word.includes('allow') || word.includes('success')) return 'ok';
  return 'neutral';
}
